import { GOLD_PRICE_API, GOLD_PRICE_STEP_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function PostGoldStepPrice(data){
  const api = `${GOLD_PRICE_STEP_API}`;
  return axiosHttp.post(api, data);
}